const apiStrings = {
  dashboardReadyForPickupApiValueText: "readyForPickup",
  dashboardReservedApiValueText: "reserved"
};

export const {
  dashboardReadyForPickupApiValueText,
  dashboardReservedApiValueText
} = apiStrings;
